import React, { useEffect, useState } from 'react';
import SlidingPanel from 'components/shared/SlidingPanel';
import { ReactComponent as IconDownload } from 'images/icons/download.svg';
import { ReactComponent as IconReport } from 'images/icons/report.svg';
import { ReactComponent as IconLink } from 'images/icons/link.svg';
import { ReactComponent as IconTwitter } from 'images/social/twitter-lg.svg';
import { ReactComponent as IconFacebook } from 'images/social/facebook-lg.svg';
import { ReactComponent as IconMessenger } from 'images/social/messenger-lg.svg';
import { ReactComponent as IconEmail } from 'images/social/email-lg.svg';
import { ReactComponent as IconCopied } from 'images/icons/copied.svg';
import clsx from 'clsx';
import Loader from 'components/shared/Loader/Loader';
import axios from 'axios';
import s from './ShareModal.module.scss';

type Props = {
  isOpen: boolean
  onClose: () => void
  handleOpenReportModal?: () => void
  videoLink?: any
  copyAndroidLink?: string
}

function ShareModal({
  isOpen,
  onClose,
  handleOpenReportModal,
  videoLink,
  copyAndroidLink,
}: Props) {
  const [isCopiedShow, setIsCopiedShow] = useState(false)
  const [videoLoading, setVideoLoading] = useState(false);
  const [currentLink, setCurrentLink] = useState('');
  const [progress, setProgress] = useState<number>();

  useEffect(() => {
    const currentURL = window.location.href.replaceAll('/null', '/');
    window.branch.link({
      data: {
        $android_url: copyAndroidLink,
        $desktop_url: currentURL,
      },
    }, (err: any, link: any) => {
      if (err) {
        console.error(err)
      } else {
        setCurrentLink(link);
      }
    })
  }, [isOpen])

  const handleCopyLink = () => {
    navigator.clipboard.writeText(currentLink)
    setIsCopiedShow(true)
  }

  const handleDownload = async () => {
    try {
      setVideoLoading(true)

      const response = await axios.get(videoLink, {
        responseType: 'blob',
        onDownloadProgress: (progressEvent) => {
          const { loaded, total } = progressEvent;
          if (!total) return;

          const percent = Math.floor((loaded * 100) / total);
          setProgress(percent);
        },
      })

      const url = window.URL.createObjectURL(response.data);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', '');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setVideoLoading(false);
      setProgress(undefined)
    } catch (error) {
      setVideoLoading(false);
      console.error('Error downloading the video:', error);
    }
  };

  useEffect(() => {
    if (isCopiedShow) {
      setTimeout(() => {
        setIsCopiedShow(false)
      }, 3000);
    }
  }, [isCopiedShow])

  const social = [
    {
      id: 0,
      name: 'Twitter',
      icon: <IconTwitter />,
      link: `http://www.twitter.com/share?url=${currentLink}`,
    },
    {
      id: 1,
      name: 'Facebook',
      icon: <IconFacebook />,
      link: `https://www.facebook.com/sharer/sharer.php?u=${currentLink}`,
    },
    {
      id: 2,
      name: 'Messenger',
      icon: <IconMessenger />,
      link: `https://www.facebook.com/dialog/send?app_id=1882309892128285&link=${encodeURIComponent(currentLink)}&redirect_uri=${encodeURIComponent(currentLink)}`,
      // link: `fb-messenger://share/?link=${currentLink}`,

    },
    {
      id: 3,
      name: 'Email',
      icon: <IconEmail />,
      link: `mailto:?body=${currentLink}`,
    },
  ]

  return (
    <SlidingPanel
      onClose={onClose}
      isOpen={isOpen}
      onClick={(e: any) => e.stopPropagation()}
      className={clsx(s.modal, 'swiper-no-swiping')}
    >
      <div
        className={s.container}
        onWheel={(e: any) => {
          e.stopPropagation()
          e.preventDefault()
          e.nativeEvent.stopPropagation()
          e.nativeEvent.stopImmediatePropagation()
        }}
      >
        <h2 className={s.title}>Share</h2>
        <div className={s.innerBody}>
          <div className={s.firstRow}>
            <div className={s.linkBtnBlock} onClick={handleCopyLink}>
              <div className={s.linkBtn}>
                <IconLink />
              </div>
              <span>
                Copy
              </span>
            </div>
            {social.slice(0, 4).map((el) => (
              <a href={el.link} key={el.id} className={s.social} target="_blank" rel="noreferrer">
                <div className={s.socialIcon}>
                  {el.icon}
                </div>
                <span>
                  {el.name}
                </span>
              </a>
            ))}
          </div>
          {videoLink ? (
            <>
              <div className={s.divider} />
              <div className={s.thirdRow}>
                <div className={s.secondaryBtnBlock} onClick={handleDownload}>
                  <IconDownload />
                  <span>Download</span>
                  {videoLoading && (
                    <Loader className={s.downloadLoader} />
                  )}
                  <div>
                    {!!progress && (
                      <span className={s.progress}>
                        {progress.toFixed(0)}
                        %
                      </span>
                    )}
                  </div>
                </div>
                <div className={s.divider} />
                <div
                  className={s.secondaryBtnBlock}
                  onClick={() => {
                    onClose()
                    if (handleOpenReportModal) handleOpenReportModal()
                  }}
                >
                  <IconReport />
                  <span>Report</span>
                </div>
              </div>
            </>
          ) : ''}
        </div>
        {isCopiedShow
          && (
            <div className={s.copiedBlock}>
              <IconCopied />
              <span>Copied</span>
            </div>
          )}
      </div>
    </SlidingPanel>
  )
}

export default ShareModal
